import { render, staticRenderFns } from "./HeaderMenuList.vue?vue&type=template&id=08d10f65&scoped=true&"
import script from "./HeaderMenuList.vue?vue&type=script&lang=js&"
export * from "./HeaderMenuList.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMenuList.vue?vue&type=style&index=0&id=08d10f65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d10f65",
  null
  
)

export default component.exports